import { NavCard } from "../NavCard";
import { SimpleNavCardProps } from "./SimpleNavCard.props";

/**
 * A simple navigation card component.
 */
/**
 * @deprecated
 */
export const SimpleNavCard = (props: SimpleNavCardProps) => {
  const { id, testId, className, title, description, icon, illustration, isWIP, path } = props;

  return (
    <NavCard className={className} id={id} testId={testId} path={path}>
      {illustration && <NavCard.Illustration testId={testId} illustration={illustration} />}
      <NavCard.Icon testId={testId} icon={icon} />
      <NavCard.Content testId={testId} title={title} description={description} />
      {isWIP && <NavCard.Tag>WIP</NavCard.Tag>}
    </NavCard>
  );
};
